document.addEventListener("DOMContentLoaded", () => {
  const SELECTOR_CONTAINER = ".pushowl-embedded-form-container";
  const SELECTOR_LEGAL = ".pushowl-form-policy";

  let stopped = false;
  let intervalId = null;
  let observer = null;

  function buildLegalDiv() {
    const legalDiv = document.createElement("div");
    legalDiv.className = "pushowl-form-policy";
    legalDiv.style.cssText =
      "margin-top:10px; font-size:12px; line-height:1.4; color:#000;";
    legalDiv.innerHTML = `
      By submitting your information, you agree to our
      <a href="https://www.kodalights.com/policies/privacy-policy" target="_blank" rel="noopener noreferrer" style="text-decoration: underline; color: #0094d6;">Privacy Policy</a>,
      <a href="https://www.kodalights.com/policies/terms-of-service" target="_blank" rel="noopener noreferrer" style="text-decoration: underline; color: #0094d6;">Terms of Service</a>,
      and acknowledge our
      <a href="https://www.kodalights.com/policies/privacy-policy#notice-financial" target="_blank" rel="noopener noreferrer" style="text-decoration: underline; color: #0094d6;">Notice of Financial Incentive</a>
      regarding any discounts or rewards offered in exchange for your personal information.
    `;
    return legalDiv;
  }

  function tryReplaceOnce(container) {
    if (!container || container.dataset.legalDone === "1") return false;

    // 找到容器中最後一個 <p>（不限層級）
    const pTags = container.querySelectorAll("p");
    const policyP = pTags[pTags.length - 1];
    if (!policyP) return false;

    // 已經有自訂區塊就標記完成
    if (container.querySelector(SELECTOR_LEGAL)) {
      container.dataset.legalDone = "1";
      return true;
    }

    const legalDiv = buildLegalDiv();

    // 用「插在前面 + 移除原 P」的方式等同替換，較不會被框架或 Proxy 節點卡住
    policyP.insertAdjacentElement("beforebegin", legalDiv);
    policyP.remove();

    container.dataset.legalDone = "1";
    return true;
  }

  function sweepAllContainers() {
    const containers = document.querySelectorAll(SELECTOR_CONTAINER);
    if (!containers.length) return false;

    let changed = false;
    containers.forEach((c) => {
      const ok = tryReplaceOnce(c);
      if (ok) changed = true;
    });
    return changed;
  }

  function stopAll(reason) {
    if (stopped) return;
    stopped = true;
    if (observer) observer.disconnect();
    if (intervalId) clearInterval(intervalId);
    // console.log("[legal-inject] stopped:", reason);
  }

  function bootstrap() {
    // 1) 先掃一次
    const firstChanged = sweepAllContainers();
    if (firstChanged) {
      // 多等一下，確認 app 不會立刻重畫覆蓋
      setTimeout(() => {
        // 若仍保持替換狀態就關閉一切
        const pending = [...document.querySelectorAll(SELECTOR_CONTAINER)]
          .some((c) => c.dataset.legalDone !== "1");
        if (!pending) stopAll("initial success");
      }, 600);
    }

    // 2) 啟動 Observer
    observer = new MutationObserver(() => {
      const changed = sweepAllContainers();
      if (changed) {
        // 給 app 一點點時間重繪；若 1 秒後仍然是成功狀態就停
        setTimeout(() => {
          const pending = [...document.querySelectorAll(SELECTOR_CONTAINER)]
            .some((c) => c.dataset.legalDone !== "1");
          if (!pending) stopAll("observer success");
        }, 1000);
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });

    // 3) 啟動後備 Interval（最多 10 秒）
    const deadline = Date.now() + 10000;
    intervalId = setInterval(() => {
      const changed = sweepAllContainers();
      const pending = [...document.querySelectorAll(SELECTOR_CONTAINER)]
        .some((c) => c.dataset.legalDone !== "1");
      if (changed && !pending) stopAll("interval success");
      if (Date.now() > deadline) stopAll("timeout");
    }, 300);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootstrap);
  } else {
    bootstrap();
  }
});

